import ProjectRow from './ProjectRow';
import { PROJECTS } from '../data';

// 상태 요약은 데이터에서 계산해 항목이 늘어도 어긋나지 않게 한다
function summary() {
  const counts = PROJECTS.reduce((acc, p) => {
    acc[p.status] = (acc[p.status] || 0) + 1;
    return acc;
  }, {});
  return Object.entries(counts)
    .map(([label, n]) => `${String(n).padStart(2, '0')} ${label}`)
    .join(' · ');
}

export default function Projects() {
  return (
    <section id="projects" className="lw-section lw-projects">
      <div className="lw-projects__head">
        <h2 className="lw-h2">Projects</h2>
        <p className="lw-mono">{summary()}</p>
      </div>

      {/* 배열은 최신순이지만 번호는 만든 순서(가장 오래된 것이 01)로 매긴다 */}
      {PROJECTS.map((p, i) => (
        <ProjectRow
          key={p.id}
          project={p}
          index={String(PROJECTS.length - i).padStart(2, '0')}
        />
      ))}
    </section>
  );
}
